<template>
  <div class="free-hot">
    <com-h1 title="程序员充电周"></com-h1>
    <div class="desc-wrapper">
      <p v-for="item in desc" :key="item">{{item}}</p>
    </div>
    <div class="welfare-wrapper">
      <com-h1 title="福利"></com-h1>
      <div class="welfares">
        <welfare-item v-for="item in welfareList" :itemData="item" :key="item.title"></welfare-item>
      </div>
    </div>
    <div class="rules-wrapper">
      <com-h1 title="领取规则"></com-h1>
      <div class="rules-container">
        <div class="rules-content">
          <h3>扫描二维码领取</h3>
          <p class="p1" v-html="ruleContent.content"></p>
          <p class="p2">*活动最终解释权归 ArchSummit 所有</p>
        </div>
        <div class="qcode">
          <img src="./assets/qrcode.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComH1 from '@/components/com-h1'
import welfareItem from './welfare-item.vue'
export default {
  data () {
    return {
      desc: [
        '在全球架构师峰会7折倒计时两周之际，我们重磅推出了“程序员充电周”活动～',
        '准备了满满四大干货福利，一起来看看吧！'
      ],
      welfareList: [
        {
          title: '30+来自QCon、ArchSummit大会的“微服务”PPT干货大合集',
          linkUrl: 'https://pan.baidu.com/s/1uVc4Ggtxe3cDU3XADciRQw',
          picUrl: 'https://static001.infoq.cn/resource/image/77/32/776a31421b7e2456dd3d7d547a2bf532.jpg',
          hotImg: 'https://static001.infoq.cn/resource/image/c6/23/c695a4b5ab6dbcfca244eb180f6ced23.png'
        },
        {
          title: '价值129元的极客时间专栏《许式伟的架构课》',
          linkUrl: 'https://time.geekbang.org/column/intro/166',
          picUrl: 'https://constatic.geekbang.org/infoq/5d5fb0085d37f.png',
          hotImg: 'https://static001.infoq.cn/resource/image/45/1b/457c69cbdd5e5167b03077077f45e51b.png'
        },
        {
          title: '价值69元的实体书籍《重构-改善既有代码的设计》',
          linkUrl: '',
          picUrl: 'https://static001.infoq.cn/resource/image/67/0a/679f56719ebd3e722b9c940e3886180a.jpg',
          hotImg: 'https://static001.infoq.cn/resource/image/a4/84/a4c8705f3ccc9eb2425635c6966f0084.png'
        },
        {
          title: '极客时间大礼包一套',
          linkUrl: 'http://rrd.me/ekUyp',
          picUrl: 'https://static001.infoq.cn/resource/image/f2/28/f2331404924aadccc7247212414e8c28.jpg',
          hotImg: 'https://static001.infoq.cn/resource/image/da/b5/dafd9528ad6798af264b7d53b97f1ab5.png'
        }
      ],
      ruleContent: {
        content: '凡参与者均可获得"微服务"PPT合集+极客时间礼包<br />前10名可另得专栏《许式伟架构课》<br />11-40名另得实体书《重构》'
      }
    }
  },
  components: {
    ComH1,
    welfareItem
  }
}
</script>

<style lang="scss" scoped>
@mixin mobile {
  @media screen and (max-width: 768px) {
    @content
  }
};
@mixin tablet {
  @media screen and (min-width: 769px) {
    @content
  }
};
.free-hot {
  padding: 60px 0px;
}
.desc-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -10px;
  margin-bottom: 50px;
  p {
    display: block;
    color: #A4ACB3;
    font-size: 16px;
    line-height: 24px;
    @include mobile() {
      padding: 10px;
      font-size: 14px;
    }
  }
}
.welfare-wrapper {
  background: #F6F7F9;
  padding: 80px 0px;
  @include mobile() {
    padding: 40px 0px;
  }
  .welfares {
    width: 1200px;
    margin: 0px auto;
    display: flex;
    margin-top: 60px;
    margin-bottom: 50px;
    @include mobile() {
      width: 100vw;
      flex-wrap: wrap;
      padding: 10px;
      margin-top: 20px;
      margin-bottom: 0px;
    }
  }
}
.rules-wrapper {
  padding: 80px 0px;
  width: 1000px;
  margin: 0px auto;
  @include mobile() {
    width: 100vw;
    padding: 40px 0px;
  }
  .rules-container {
    display: flex;
    @include mobile() {
      display: block;
    }
    .rules-content {
      flex: 2;
      @include mobile() {
        width: 100%;
        padding: 10px;
        text-align: center;
      }
      h3 {
        font-weight: 600;
        color: #000;
        font-size: 24px;
        line-height: 70px;
        @include mobile() {
          font-size: 16px;
        }
      }
      .p1 {
        color: #99A1A9;
        font-weight: 400;
        font-size: 20px;
        line-height: 40px;
        @include mobile() {
          font-size: 14px;
          line-height: 24px;
        }
      }
      .p2 {
        color: #99A1A9;
        font-size: 15px;
        line-height: 40px;
        @include mobile() {
          font-size: 14px;
        }
      }
    }
    .qcode {
      flex: 1;
      display: flex;
      justify-content: center;
      @include mobile() {
        width: 100%;
      }
      img {
        display: block;
        width: 210px;
        height: 210px;
        @include mobile() {
          margin-top: 20px;
          width: 50vw;
          height: 50vw;
        }
      }
    }
  }
}
</style>
